import { Address } from "@/types/Address";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/base/DropDownMenu";
import { Button } from "@/components/base/Button";
import { MapPinIcon } from "lucide-react";
import { openInGoogleMaps } from "@/lib/openInGoogleMaps";
import { openInAppleMaps } from "@/lib/openInAppleMaps";

export const OpenAddressDropdown = ({ address }: { address: Address }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="mr-3" size={"icon"}>
          <MapPinIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => {
            openInGoogleMaps(address);
          }}
        >
          Open In Google Maps
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            openInAppleMaps(address);
          }}
        >
          Open In Apple Maps
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
